const tagCollator = new Intl.Collator("en", { sensitivity: "base", numeric: true });

export function sortTagDefs(tagDefs) {
  return [...(tagDefs || [])].sort(
    (a, b) => tagCollator.compare(a.label || "", b.label || "") || tagCollator.compare(a.key || "", b.key || "")
  );
}

export function filterUserTags(tags, tagDefs) {
  return (tags || []).filter((key) => {
    const def = tagDefs.find((d) => d.key === key);
    return def && !def.auto;
  });
}

export function tagFilterEmptyMessage(noun, selectedKeys, tagDefs, match) {
  if (!selectedKeys.length) return "";
  const labels = selectedKeys.map((key) => tagDefs.find((d) => d.key === key)?.label ?? key);
  if (labels.length === 1) return `No ${noun} tagged ${labels[0]}`;
  const any = match === "any";
  const lead = labels.length === 2 ? (any ? "either" : "both") : any ? "any of" : "all of";
  return `No ${noun} with ${lead}: ${labels.join(any ? " or " : " + ")}`;
}
